import React, {Component} from 'react'
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from 'antd'
import {dateVal, strVal} from '../../../../../../../modules/Utils'
import {boolVal} from '../../../../../../../modules/Utils'

const FormItem = Form.Item
const {Option} = Select

class KeyTerms extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {workOrder} = this.props
    return (
      <div>
        <Form layout="horizontal">
          <Row>
            <Col span={12}>
              <FormItem label="Title" {...formItemLayout}>
                {getFieldDecorator('title', {
                  initialValue: strVal(workOrder, 'title'),
                  rules: [{required: true, message: "Title can't be empty "}],
                })(<Input placeholder="Title" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Time Sheet based" {...formItemLayout}>
                {getFieldDecorator('timesheet', {
                  initialValue: boolVal(workOrder, 'timesheet'),
                  rules: [
                    {
                      required: true,
                      message: "Time Sheet based can't be empty ",
                    },
                  ],
                  valuePropName: 'checked',
                })(<Checkbox placeholder="Time Sheet based" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Order Date" {...formItemLayout}>
                {getFieldDecorator('date.order', {
                  rules: [
                    {
                      required: true,
                      message: "Order Date can't be empty ",
                    },
                  ],
                  initialValue: dateVal(workOrder, 'date.order'),
                })(
                  <DatePicker
                    style={{width: '100%'}}
                    placeholder="Order Date"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Validity Start" {...formItemLayout}>
                {getFieldDecorator('date.effective', {
                  initialValue: dateVal(workOrder, 'date.effective'),
                  rules: [
                    {
                      required: true,
                      message: "Start Date can't be empty ",
                    },
                  ],
                })(
                  <DatePicker
                    style={{width: '100%'}}
                    placeholder="Validity Start"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Validity End" {...formItemLayout}>
                {getFieldDecorator('date.expiry', {
                  initialValue: dateVal(workOrder, 'date.expiry'),
                })(
                  <DatePicker style={{width: '100%'}} placeholder="End Date" />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Max Order Value" {...formItemLayout}>
                {getFieldDecorator('maxOrderValue', {
                  initialValue: strVal(workOrder, 'maxOrderValue'),
                  rules: [
                    {
                      required: true,
                      message: "Max Order Value Amount can't be empty ",
                    },
                  ],
                })(
                  <InputNumber
                    style={{width: '100%'}}
                    placeholder="Max Order Value"
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

export default Form.create()(KeyTerms)
